import React from 'react';
import Box from '@mui/joy/Box';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TrackingEventForm from '../widgets/TrackingEventForm';

export default function EditTrackingEventScreen() {
  const { id } = useParams();
  const { t } = useTranslation('ui');
  return (
    <Box sx={{ display: 'flex' }} m={3}>
      <Box width="100%">
        <Breadcrumbs separator={<KeyboardArrowRight />} aria-label="breadcrumbs" sx={{ mb: 1 }}>
          <Link href="/shipments" color="neutral">
            {t('nav.shipments')}
          </Link>
          <Link href="/shipment/tracking-events" color="neutral">
            {t('trackingEvent.breadcrumbList')}
          </Link>
          <Typography>{t('trackingEvent.breadcrumbEdit', { id })}</Typography>
        </Breadcrumbs>
        <TrackingEventForm formType="edit" eventId={id ? parseInt(id, 10) : null} />
      </Box>
    </Box>
  );
}
